/**
 * Afterpay (Square) messaging — keep the PDP <square-placement> amount in sync with the
 * selected variant. The placement lives OUTSIDE the auto-swapped #Price- node (so it can
 * render on its own full-width line), so it no longer gets refreshed by the section swap.
 *
 * Subscribes to theme.PUB_SUB_EVENTS.variantChange, payload:
 *   { data: { sectionId, variant: <shopify variant json, price in cents> } }
 * On change it rebuilds the placement element (Square hydrates freshly-inserted custom
 * elements via connectedCallback), which is the same mechanism the section swap relied on.
 */
(function () {
  if (window.__afterpayMessagingBound) return;

  function updatePlacement(sectionId, variant) {
    if (!variant || typeof variant.price !== 'number') return;

    var block = document.querySelector(
      '[data-afterpay-block][data-section-id="' + sectionId + '"]'
    );
    if (!block) return;

    var current = block.querySelector('[data-afterpay-placement]');
    if (!current) return;

    var amount = (variant.price / 100).toString();
    var sku = variant.sku == null ? '' : String(variant.sku);

    // No-op if nothing changed (avoids needless re-hydration).
    if (
      current.getAttribute('data-amount') === amount &&
      current.getAttribute('data-item-skus') === sku
    ) {
      return;
    }

    var fresh = current.cloneNode(false);
    fresh.setAttribute('data-amount', amount);
    fresh.setAttribute('data-item-skus', sku);
    current.replaceWith(fresh);
  }

  function init() {
    if (
      !window.theme ||
      !window.theme.PUB_SUB_EVENTS ||
      typeof window.subscribe !== 'function'
    ) {
      return false;
    }
    window.__afterpayMessagingBound = true;
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.sectionId) return;
      updatePlacement(data.sectionId, data.variant);
    });
    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!init()) {
        setTimeout(init, 500);
      }
    });
  }
})();
